// extracted by mini-css-extract-plugin
export default {"transactions":"TransactionHistory_transactions__+SUr8"};